var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSessionPulseChecksReporting = function SvgSessionPulseChecksReporting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 111 83"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#session-pulse-checks-reporting_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M52.699 29.49H13.95l-7.203 8.068V29.49H.063V.156h52.636z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.068 8.773H8.694v1.59h35.374zM44.068 14.029H8.694v1.589h35.374zM44.068 19.285H8.694v1.589h35.374z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M6.855 42.495c.735 0 1.33-.599 1.33-1.337 0-.74-.595-1.338-1.33-1.338s-1.33.599-1.33 1.338c0 .738.595 1.337 1.33 1.337"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F616A",
    d: "M92.976 80.45h-1.491l-.71-5.782h2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M93.356 81.902H88.55v-.061c0-.5.197-.978.547-1.33s.827-.551 1.323-.551h2.936z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F616A",
    d: "m78.448 80.33-1.413-.476 1.155-5.707 2.086.703z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "m78.35 81.83-4.558-1.537.02-.058c.157-.473.496-.863.94-1.086a1.86 1.86 0 0 1 1.428-.1l2.783.939zM80.286 50.574l-3.228 27.454 3.166.269s4.98-26.993 6.514-23.795c1.536 3.197 3.417 23.196 3.417 23.196h3.142s.805-31.203-2.484-32.747z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F616A",
    d: "M88.652 27.956a3.196 3.196 0 0 0-2.58-3.704 3.18 3.18 0 0 0-3.684 2.594 3.196 3.196 0 0 0 2.58 3.704 3.18 3.18 0 0 0 3.684-2.594"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m83.63 31.775 4.057.331s3.235.055 4.551.937-1.261 6.34-1.261 6.34-.67 2.164-.164 3.142c1.64 3.175 1.397 5.62 1.397 5.62s-3.371.775-9.183 2.319c0 0-3.619 1.433-3.51.662.11-.772 1.207-9.593 1.207-9.593v-9.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M90.728 27.055c-.162-.91-.526-2.203-1.336-3.182h.076c.279-.008.595-.096.71-.35a.61.61 0 0 0-.11-.61 1.8 1.8 0 0 0-.507-.398c.195.12.471.23.627.063a.34.34 0 0 0 .038-.364.9.9 0 0 0-.243-.295 6 6 0 0 0-1.072-.76c-.297-.166-.688-.298-.955-.087-.272.215-.228.634-.158.974a1.1 1.1 0 0 0-.5-.151.38.38 0 0 0-.382.296.4.4 0 0 0 .177.344c-1.049-.173-2.389.024-4.101.82 0 0-1.661.557-1.745 2.755-.009.352.03.703.115 1.044.094.399.426 2.353.027 3.143l2 .717.023-1.205c-1.554-2.256-.787-3.084-.181-4.44l.005-.007.007-.002a.014.014 0 0 1 .013.007c.112.193.54.854 2.016.854l-.57-.573s2.508 1.032 3.42 1.032c0 0 .683.458 0 1.146-.684.687-2.181 1.7-1.383 2.96s.729 1.709.729 1.709l1.824-1.032s1.114-2.216 1.311-2.869a3.3 3.3 0 0 0 .125-1.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E72ED",
    d: "M68.812 51.902h36.284v20.222h-4.609v5.56l-4.965-5.56h-26.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M99.146 57.842H74.761v1.096h24.385zM99.146 61.465H74.761v1.096h24.385zM99.146 65.088H74.761v1.096h24.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F616A",
    d: "m92.636 38.946-2.129.52-.016 4.33-2.393 8.307a1.35 1.35 0 0 0-.485 1.306 1.35 1.35 0 0 0 .927 1.036 1.33 1.33 0 0 0 1.342-.346 1.35 1.35 0 0 0 .317-1.356l2.862-8.6zM78.471 38.855l2.553.733.016 4.33 2.394 8.308a1.34 1.34 0 0 1 .484 1.305 1.35 1.35 0 0 1-.926 1.036 1.33 1.33 0 0 1-1.342-.345 1.35 1.35 0 0 1-.317-1.357l-2.862-8.599z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m89.442 32.602.527-.173c.297-.097.619-.074.899.063 0 0 1.535.11 1.754 1.213s.753 10.74.753 10.74l-3.252-1.04zM82.04 32.602l-.934-.047-.295-.149s-1.732.196-1.951 1.299-.858 11.037-.858 11.037l3.252-.892z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "m28.409 71.664 1.541-1.352a26 26 0 0 0-.36-2.895l-.85.362.789-.692a23 23 0 0 0-.452-1.95s-3.11 2.777-4.85 6.164l.763 2.525-1.166-1.67q-.261.605-.443 1.239c-1.214 4.256-.815 8.105.89 8.596 1.706.492 4.072-2.56 5.285-6.816a13.9 13.9 0 0 0 .428-4.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "m32.49 74.974 2.015-.357q.665-1.299 1.18-2.665l-.914-.133 1.031-.182c.413-1.13.616-1.904.616-1.904s-4.09.76-7.321 2.756l-.645 2.558-.14-2.035a10 10 0 0 0-1.016.83c-3.226 3.012-4.864 6.514-3.656 7.821 1.207 1.308 4.801-.075 8.028-3.088a13.8 13.8 0 0 0 2.515-3.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M109.915 82.045H18.568a.15.15 0 0 1-.147-.149.15.15 0 0 1 .147-.148h91.347a.149.149 0 0 1 0 .297"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "session-pulse-checks-reporting_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.063.156h110v82h-110z"
  })))));
};
export { SvgSessionPulseChecksReporting as ReactComponent };
export default __webpack_public_path__ + "fonts/session-pulse-checks-reporting-9444faca37676833646c1227ebcd8014.svg";